import React from 'react'
import { getMobileOS } from 'utils/mobile'

import AndroidMobileBanner from './Android'
import IOSMobileBanner from './iOS'

const MobileBanners = ({ onClose }) => {
  const mobileOs = getMobileOS()
  if (mobileOs === 'Android') return <AndroidMobileBanner onClose={onClose} />
  if (mobileOs === 'iOS') return <IOSMobileBanner onClose={onClose} />
  return null
}

export default MobileBanners
